<template>
  <main>
    <warehouse-list :action-str-mount-chained="actionMountChained" :action-str-select-chained="actionSelectChained" />
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('coolerInventory.title') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <search-filter ref="searchFilter" @shipper-changed="shipperChanged" />
        </el-col>
      </el-row>
       <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="8" class="default-section-title">
              {{ $t('coolerInventory.summary') }}
              <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
              </el-tooltip>
            </el-col>
            <el-col :span="12" class="default-section-actions text-align-end">
              <print-dialog />
              <print-return-receipt :shipperName="selectedShipperName" />
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col>
              <search-summary />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>
<script>

import WarehouseList from '@/components/WarehouseList/WarehouseList';
import SearchFilter from './SearchFilter';
import SearchSummary from './SearchSummary';
import PrintDialog from './components/PrintDialog';
import PrintReturnReceipt from './components/PrintReturnReceipt';

export default {
  name: 'CoolerInventory',
  components: {
    SearchFilter,
    WarehouseList,
    SearchSummary,
    PrintDialog,
    PrintReturnReceipt
  },
  data() {
    return {
      actionMountChained: ['coolerInventory/setDefaultFilters'],
      actionSelectChained: ['coolerInventory/search'],
      selectedShipperName: '',
    };
  },
  methods: {
    handleRefresh() {
      this.$refs.searchFilter.handleSearch();
    },
    shipperChanged(data) {
      this.selectedShipperName = data;
    }
  }
};
</script>
